import React, { createContext, useState, useEffect, useContext, ReactNode } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";

interface FilterSettingsContextType {
	isFilterSettingsOpen: boolean;
	setIsFilterOpen: (value: boolean) => Promise<void>;
}

const FilterSettingsContext = createContext<FilterSettingsContextType>({
	isFilterSettingsOpen: false,
	setIsFilterOpen: async () => {},
});

export const FilterSettingsProvider = ({ children }: { children: ReactNode }) => {
	const [isFilterSettingsOpen, setIsFilterOpenState] = useState(false);

	const saveFilterSettings = async (value: boolean) => {
		try {
			await AsyncStorage.setItem("isFilterOpen", JSON.stringify(value));
			setIsFilterOpenState(value);
		} catch (error) {
			console.error("Error saving filter settings:", error);
		}
	};

	const getFilterSettings = async () => {
		try {
			const data = await AsyncStorage.getItem("isFilterOpen");
			if (data !== null) {
				setIsFilterOpenState(JSON.parse(data));
			} else {
				// Set default value if not found in AsyncStorage
				await saveFilterSettings(false);
			}
		} catch (error) {
			console.error("Error retrieving filter settings:", error);
		}
	};

	useEffect(() => {
		getFilterSettings();
	}, []);

	return <FilterSettingsContext.Provider value={{ isFilterSettingsOpen, setIsFilterOpen: saveFilterSettings }}>{children}</FilterSettingsContext.Provider>;
};

export const useFilterSettings = () => {
	const context = useContext(FilterSettingsContext);
	if (!context) {
		throw new Error("useFilterSettings must be used within a FilterSettingsProvider");
	}
	return context;
};
